module.exports = __webpack_public_path__ + "img/RPAZL.99c3d84f.png";